import type { TransformRow } from '../transforms/types';

/**
 * Split a signed delta column into WaterfallChart's two-series shape (each
 * row contributes a positive AND a negative value; the unused side is 0).
 * Zeros go to the positive side so segments with no change still render.
 */
export function splitWaterfallDelta(
  rows: TransformRow[],
  opts: {
    valueKey: string;
    positiveSeriesKey: string;
    negativeSeriesKey: string;
  },
): TransformRow[] {
  const { valueKey, positiveSeriesKey, negativeSeriesKey } = opts;
  return rows.map((row) => {
    const raw = row[valueKey];
    const num = typeof raw === 'number' ? raw : Number(raw);
    // Non-numeric / non-finite deltas become 0 (flat segment) — column
    // presence is validated upstream, not value type.
    const safe = Number.isFinite(num) ? num : 0;
    return {
      ...row,
      [positiveSeriesKey]: safe >= 0 ? safe : 0,
      [negativeSeriesKey]: safe < 0 ? safe : 0,
    };
  });
}
